module.exports = __webpack_public_path__ + "static/img/main.22a3bc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/9/main.png
// module id = V8Bx
// module chunks = 1